import { render, staticRenderFns } from "./InActive.vue?vue&type=template&id=01697582"
import script from "./InActive.vue?vue&type=script&lang=ts"
export * from "./InActive.vue?vue&type=script&lang=ts"
import style0 from "./InActive.vue?vue&type=style&index=0&id=01697582&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports